<template>
    <div class="h5_detail">
        <div v-if=" productData.groupInfo && productData.buttonStatus == 7"  class="is_group">
          <div class="course_intro">
            <img class="course_img" :src="productData.headPhotoUrl" alt="">
            <div>
              <p>{{productData.groupName}}</p>
              <div>
                ¥{{productData.groupPrice}}
                <span>{{productData.buyerCount}}人团</span>
              </div>
            </div>
            <img class="success_icon" src="https://appd.knowbox.cn/ss/activity/group-buy/buy-success.png" alt="">
          </div>
          <groupPerson :headList="productData.groupInfo.headList"></groupPerson>
          <p class="group_text">该团<span>已经拼课成功！</span>自己开团试试吧！</p>
          <button  @click="dopay" class="pay">
            <span>¥{{productData.groupPrice}}</span> 
            <span >我也要开团</span>
          </button>
        </div>
        <div v-if=" productData.groupInfo && productData.buttonStatus == 3"  class="no_group">
          <div class="nick">
            <div>
              <img :src="productData.groupInfo && productData.groupInfo.headUrl" alt="">
              <span>我是{{productData.groupInfo && productData.groupInfo.groupProducer}}</span>              
            </div>
            <span>拼团中</span>
          </div>
          <div class="join">
            <p>我花<span>¥{{productData.groupPrice}}</span>拼到了《{{productData.groupName}}》，</p>
            <p>超值体验，邀请你一起参加！</p>
          </div>
          <groupPerson :headList="productData.groupInfo.headList"></groupPerson>
          <p class="rest_time">剩余 <span>{{time[0]}}:{{time[1]}}:{{time[2]}}</span> 结束</p>
          <button @click="dopay">我要参团</button>
        </div>
        <productDetail 
          :productData="productData"
          @selectTime="handleSelectTime"></productDetail>
        <div v-if="showBtn" class="footer">
            <div v-if="productData.buttonStatus == 7" class="purchase_0" @click="dopay">
                <div>
                    <span>¥{{productData.groupPrice}}</span> 
                    <span>我也要开团</span>
                </div>
            </div>
            <div v-if="productData.buttonStatus == 1" class="purchase_2">活动未开始</div>
            <div v-if="productData.buttonStatus == 2" class="purchase_3" >活动已结束</div>
            <div v-if="productData.buttonStatus == 3" class="purchase_1" @click="dopay">我要参团</div>
            <div v-if="productData.buttonStatus == 4" class="purchase_1_orgin">已购买</div>
        </div> 
        <login 
          :version="version"
          :channel="channel"
          :source="source"
          v-show="showLogin"
          @initData="initData"
          @close="toggleClickLogin"></login> 
    </div>
</template>

<script>
import utils from "@/assets/js/utils";
import { isIOS } from "@/utils/env";
import productDetail from "./components/product_detail.vue";
import groupPerson from "./components/group_person.vue";
import login from "./components/login.vue";

export default {
  name: "h5_detail",
  data() {
    return {
      productData: {},
      phaseId: "",
      time: 0,
      productId: 0,
      appID: "wx8cdb5bb00ac8127c",
      scope: "snsapi_userinfo",
      code: "",
      showLogin: false,
      source: "",
      version: "",
      department: "",
      state: {},
      showBtn: false
    };
  },
  components: {
    productDetail,
    groupPerson,
    login
  },
  methods: {
    initData(isClickLogin = false) {
      if (utils.getQueryString("openId")) {
        localStorage.setItem("openId", utils.getQueryString("openId"));
        localStorage.setItem("nickname", utils.getQueryString("nickname"));
        localStorage.setItem("headImgUrl", utils.getQueryString("headImgUrl"));
        this.showLogin = true;
        utils.sendLog(
          {
            token: this.token,
            version: this.version,
            source: this.source
          },
          "hzxx849"
        );
      }
      const { source, groupInfoId, groupId, version } = this;
      this.$api
        .getProductDetail({
          source,
          groupInfoId,
          groupId,
          token: localStorage.getItem("token")
        })
        .then(data => {
          utils.sendLog(
            {
              token: localStorage.getItem("token"),
              version: version,
              source: source,
              extensionJson: {
                tuangou_status: data.buttonStatus,
                tuangou_productId: groupInfoId,
                pageChannel: this.pageChannel
              }
            },
            "hzxx847"
          );
          this.productData = data;
          this.phaseId =
            data.courseTimes.length > 0 ? data.courseTimes[0].phaseId : 0;
          this.groupId = data.groupId;
          this.productId = data.productId;
          this.department = data.department;
          localStorage.setItem("shareImgUrl", data.shareImgUrl);
          localStorage.setItem("shareTitle", data.shareTitle);
          localStorage.setItem("shareDesc", data.shareDesc);
          this.timeDown(data.groupInfo ? data.groupInfo.endTime : 0);
          if (data.needLogin) {
            localStorage.removeItem("token");
            this.showLogin = true;
          }
          if (isClickLogin) {
            if (data.buttonStatus == 3 || data.buttonStatus == 7) {
              this.dopay();
            }
          }
          if (data.buttonStatus == 5 || data.buttonStatus == 6) {
            window.location.href = this.successUrl();
          }
          this.$wxShare({
            title: localStorage.getItem("shareTitle"),
            desc: localStorage.getItem("shareDesc"),
            link:
              window.location.origin +
              window.location.pathname +
              "#/group_buy/h5_detail?" +
              "groupInfoId=" +
              this.groupInfoId +
              "&groupId=" +
              this.groupId + '&pageChannel=' + localStorage.getItem('pageChannel'),
            imgUrl: localStorage.getItem("shareImgUrl")
          });
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    handleSelectTime({ id }) {
      this.phaseId = id;
    },
    timeDown(totalSeconds) {
      // console.log(totalSeconds);
      var time = [];
      //小时数
      var hours =
        Math.floor(totalSeconds / (60 * 60)) < 10
          ? "0" + Math.floor(totalSeconds / (60 * 60))
          : Math.floor(totalSeconds / (60 * 60));
      var modulo = totalSeconds % (60 * 60);
      //分钟
      var minutes =
        Math.floor(modulo / 60) < 10
          ? "0" + Math.floor(modulo / 60)
          : Math.floor(modulo / 60);
      //秒
      var seconds = modulo % 60 < 10 ? "0" + modulo % 60 : modulo % 60;
      //输出到页面
      time.push(hours, minutes, seconds);
      this.time = time;
      //延迟一秒执行自己
      let timer = setTimeout(() => {
        if (totalSeconds == 0) {
          clearTimeout(timer);
          return;
        }
        this.timeDown(totalSeconds - 1);
      }, 1000);
    },
    dopay() {
      utils.sendLog(
        {
          token: this.token,
          version: this.version,
          source: this.source,
          extensionJson: {
            tuangou_status: this.productData.buttonStatus,
            tuangou_productId: this.groupInfoId,
            pageChannel: this.pageChannel
          }
        },
        "hzxx848"
      );
      // console.log("openId", localStorage.getItem("openId"));
      if (localStorage.getItem("openId")) {
        if (localStorage.getItem("mobile")) {
          this.orderAdd();
        } else {
          this.showLogin = true;
        }
      } else {
        this.toAuth();
      }
    },
    orderAdd() {
      const {
        source,
        version,
        groupInfoId,
        groupId,
        phaseId,
        productId,
        pageChannel
      } = this;
      this.$api
        .orderAdd({
          token: localStorage.getItem("token"),
          source,
          version,
          productId,
          groupInfoId,
          groupId,
          phaseId,
          identity: "parent",
          userSource: "NEW-PARENT-GROUP-BUYING",
          clientChannel: "",
          clientVersion: "",
          deviceBrand: "",
          deviceModel: "",
          OSName: "",
          OSVersion: "",
          pageChannel,
          //微信中使用;
          openid: localStorage.getItem("openId"),
          mobile: localStorage.getItem("mobile"),
          nickname: localStorage.getItem("nickname"),
          headPhoto: localStorage.getItem("headImgUrl")
        })
        .then(data => {
          this.orderId = data.orderId;
          //h5-pay api域名
          let publicPath = {
            dev: "https://qa.knowbox.cn:8004",
            test: "https://qa.knowbox.cn:8004",
            preview: "https://preshark.knowbox.cn:8044",
            production: "https://stuapi.knowbox.cn"
          };
          //todo：h5-pay 前端域名；
          let payDomain = {
            dev: "https://betassweb.knowbox.cn:7002",
            test: "https://betassweb.knowbox.cn:7002",
            preview: "https://prefe.knowbox.cn:7001",
            production: "https://ssweb.knowbox.cn"
          };
          window.location =
            payDomain[process.env.VUE_APP_INTER] +
            "/h5-pay/dist/" +
            process.env.VUE_APP_INTER +
            "/group-buy-pay.html?token=" +
            localStorage.getItem("token") +
            "&version=" +
            this.version +
            "&source=" +
            this.source +
            "&orderId=" +
            this.orderId +
            "&payHost=" +
            escape(publicPath[process.env.VUE_APP_INTER]) +
            "&orderInfoPath=group-buying/pay/order-info&successUrl=" +
            escape(this.successUrl()) +
            "&chargePath=group-buying/pay/order-add-pay-obj&verifyPath=group-buying/pay/order-verify&orderSource=h5";
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    toAuth() {
      this.state = "groupInfoId" + this.groupInfoId + "groupId" + this.groupId;
      let publicPath = {
        dev: "https://qa.knowbox.cn:8004",
        test: "https://qa.knowbox.cn:8004",
        preview: "https://preshark.knowbox.cn",
        production: "https://stuapi.knowbox.cn"
      };
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        this.appID
      }&redirect_uri=${encodeURIComponent(
        publicPath[process.env.VUE_APP_INTER] +
          "/new-parent/wechat/wx-auth-group-buying"
      )}&response_type=code&scope=${this.scope}&state=${
        this.state
      }#wechat_redirect`;
      // console.log("toAuthUrl", url);
      window.location.href = url;
    },
    toggleClickLogin() {
      this.showLogin = !this.showLogin;
    },
    successUrl() {
      return (
        window.location.origin +
        "/#/group_buy/group_detail?hideTitleBar=1" +
        "&token=" +
        localStorage.getItem("token") +
        "&groupInfoId=" +
        this.groupInfoId +
        "&groupId=" +
        this.groupId +
        "&source=" +
        this.source +
        "&version=" +
        this.version +
        "&department=" +
        this.department
      );
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      this.showBtn = scrollTop >= 300 ? true : false;
    }
  },
  created: function() {
    this.token = localStorage.getItem("token") || "";
    this.source =
      utils.getQueryString("source") || isIOS()
        ? "iphoneNewParent"
        : "androidNewParent";
    this.version = utils.getQueryString("version") || "4093";
    this.channel = utils.getQueryString("channel") || "Knowbox";
    this.groupInfoId = utils.getQueryString("groupInfoId");
    this.groupId = utils.getQueryString("groupId");
    this.pageChannel = utils.getQueryString("pageChannel");
    localStorage.setItem('pageChannel',this.pageChannel);
    if (process.env.VUE_APP_INTER == "production") {
      this.appID = "wxcc12cdd1a94fc413";
    }
    this.initData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
.h5_detail {
  background: #f5f5f5;
  .is_group {
    background: #fff;
    overflow: hidden;
    .pay {
      width: 6rem;
      height: 1rem;
      background-color: #ff5c5c;
      border-radius: 0.5rem;
      color: #fff;
      margin-left: calc((100% - 6rem) / 2);
      margin-bottom: 0.7rem;
      font-weight: bolder;
      span {
        display: block;
        font-family: PingFangSC-Medium;
        &:nth-child(1) {
          font-size: 0.36rem;
          height: 0.36rem;
          margin-bottom: 0.1rem;
        }
        &:nth-child(2) {
          font-size: 0.24rem;
        }
      }
    }
    .course_intro {
      display: flex;
      align-items: center;
      padding: 0.4rem 0;
      margin: 0 0.3rem 0.6rem 0.3rem;
      border-bottom: 0.01rem solid #eeeeee;
      position: relative;
      .course_img {
        width: 2rem;
        height: 1.28rem;
        margin-right: 0.2rem;
        border-radius: 0.08rem;
      }
      .success_icon {
        width: 1.34rem;
        height: 1.13rem;
        position: absolute;
        right: -0.3rem;
        top: 0.31rem;
      }
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 4.69rem;
        height: 1.28rem;
        p {
          font-family: PingFangSC-Semibold;
          font-size: 0.32rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #5f6162;
        }
        div {
          font-weight: normal;
          font-stretch: normal;
          color: #ff5c5c;
          display: flex;
          font-family: PingFangSC-Semibold;
          font-size: 0.42rem;
          height: 0.42rem;
          align-items: center;
          span {
            display: block;
            margin-left: 0.1rem;
            width: 0.7rem;
            height: 0.28rem;
            background-color: #ff5c5c;
            border-radius: 0.14rem;
            text-align: center;
            line-height: 0.28rem;
            color: #fff;
            font-family: PingFangSC-Regular;
            font-size: 0.2rem;
          }
        }
      }
    }
    .group_text {
      width: 100%;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #5f6162;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin: 0.39rem 0 0.7rem;
      span {
        color: #ff7070;
      }
      &::after {
        content: "";
        display: block;
        width: 0.2rem;
        height: 0.02rem;
        background-color: #dbdbdb;
        position: absolute;
        left: 0.81rem;
        top: 0.13rem;
      }
      &::before {
        content: "";
        display: block;
        width: 0.2rem;
        height: 0.02rem;
        background-color: #dbdbdb;
        position: absolute;
        right: 1rem;
        top: 0.13rem;
      }
    }
  }
  .no_group {
    .nick {
      padding: 0.4rem 0.3rem 0.6rem 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
        img {
          width: 0.56rem;
          height: 0.56rem;
          background-color: #eeeeee;
          border-radius: 0.28rem;
          margin-right: 0.16rem;
        }
        span {
          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #5f6162;
        }
      }
      > span {
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        font-weight: bolder;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ff5c5c;
      }
    }
    .join {
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 0.36rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #424243;
      margin-bottom: 0.58rem;
      p {
        span {
          color: #ff5c5c;
        }
      }
    }
    .rest_time {
      text-align: center;
      margin: 0.3rem 0 0.7rem 0;
      font-family: PingFangSC-Medium;
      font-size: 0.3rem;
      height: 0.3rem;
      line-height: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #5f6162;
      position: relative;
      span {
        color: #ff5c5c;
      }
      &::after {
        content: "";
        display: block;
        width: 0.2rem;
        height: 0.02rem;
        background-color: #dbdbdb;
        position: absolute;
        left: 2.09rem;
        top: 0.13rem;
      }
      &::before {
        content: "";
        display: block;
        width: 0.2rem;
        height: 0.02rem;
        background-color: #dbdbdb;
        position: absolute;
        right: 2.09rem;
        top: 0.13rem;
      }
    }
    button {
      width: 6rem;
      height: 1rem;
      background-color: #ff5c5c;
      border-radius: 0.5rem;
      color: #fff;
      margin-left: calc((100% - 6rem) / 2);
      margin-bottom: 0.7rem;
      font-size: 0.34rem;
      font-weight: bolder;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    .purchase {
      &_0 {
        display: flex;
        height: 1rem;
        div {
          background: #ff5c5c;
          width: 100%;
          font-size: 0.24rem;
          color: #fff;
          font-family: PingFangSC-Medium;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          span:nth-child(1) {
            font-size: 0.36rem;
            color: #fff;
            height: 0.4rem;
          }
        }
      }
      &_1 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #ff5c5c;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ffffff;
        &_orgin {
          color: #fff;
          background: #d2d3d4;
        }
      }
      &_2 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #fff;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ff5c5c;
      }
      &_3 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #d2d3d4;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #fff;
      }
    }
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .h5_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .h5_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .h5_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}
</style>